import React, { Component } from 'react';
import t from '../../../utils/translations';
import { InputGroup } from './InputGroup';
import { calculateRoi, isIntegrated, formatMoney } from '../../../utils/fn';

if (!isIntegrated()) {
  import('./Roi.scss');
}

// return of investment component
class Roi extends Component {

  state = {
    selectedVegetables: [],
    variationsIndex: 0,
    inputData: {
      human: '',
      machine: '',
      quantityPerDay: '',
      workingDaysPerYear: '',
      workingDaysPerWeek: '',
      labourCostPerHour: '',
      socialFee: '',
      listPrice: '',
    },
    resultData: {
      moneySavedFirstQuarter: 0,
      moneySavedFirstYear: 0,
      paybackTime: 0,
      paybackTimeSuffix: '',
      timeSaved: 0,
      timeSavedSuffix: '',
    },
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleVegetableChange = this.handleVegetableChange.bind(this);
    this.addVegetable = this.addVegetable.bind(this);
    this.removeVegetable = this.removeVegetable.bind(this);
  }

  componentDidMount() {
    let nrOfVegetablesAtStart = 3;
    let selectedVegetables = [];
    for (let i = 0; i < nrOfVegetablesAtStart; i++) {
      if (i in this.props.product.variations) {
        const {
          human,
          machine,
          default_amount,
        } = this.props.product.variations[i].data;
        selectedVegetables.push({
          value: i,
          human: human,
          machine: machine,
          quantityPerDay: Number(default_amount),
        });
      }
    }

    const {
      hourly_labour_cost,
      social_fee_percentage,
      weekly_working_days,
      yearly_working_days,
    } = this.props.default_values;

    const { data, price, } = this.props.product.variations[0];

    const inputData = {
      vegetables: selectedVegetables,
      quantityPerDay: Number(data.default_amount),
      workingDaysPerYear: Number(yearly_working_days),
      workingDaysPerWeek: Number(weekly_working_days),
      labourCostPerHour: Number(hourly_labour_cost),
      socialFee: Number(social_fee_percentage),
      listPrice: Number(price),
    };

    const resultData = calculateRoi(inputData);

    this.setState({
      selectedVegetables: selectedVegetables,
      inputData,
      resultData,
    });
  }

  handleChange(data) {
    const inputData = {
      ...this.state.inputData,
      [data.name]: Number(data.value),
    };

    const resultData = calculateRoi(this.fixRoiData(inputData));

    this.setState({
      inputData,
      resultData,
    });
  }

  handleVegetableChange(e, key, updatingQuantity = false) {

    if (e.target.value < 1) {
      e.preventDefault();
      e.target.value = 1;
      return;
    }

    const newSelectedVegetables = this.state.selectedVegetables;

    if (updatingQuantity) {
      newSelectedVegetables[key].quantityPerDay = e.target.value;
    } else {
      newSelectedVegetables[key].value = e.target.value;
    }

    const vegetables = [];

    newSelectedVegetables.forEach(vegetable => {

      if (vegetable.value in this.props.product.variations) {
        const {
                human,
                machine,
              } = this.props.product.variations[vegetable.value].data;
        vegetables.push({
          human: Number(human),
          machine: Number(machine),
          quantityPerDay: Number(vegetable.quantityPerDay),
          value: Number(vegetable.value),
        });
      }

    });

    const inputData = {
      ...this.state.inputData,
      vegetables: vegetables,
    };

    const resultData = calculateRoi(this.fixRoiData(inputData));

    this.setState({
      selectedVegetables: newSelectedVegetables,
      resultData: resultData,
    });
  }

  // This makes sure that all values are given
  fixRoiData = (data) => {

    const defaultValues = this.props.default_values;

    data.labourCostPerHour = data.labourCostPerHour || defaultValues.hourly_labour_cost;
    data.quantityPerDay = data.quantityPerDay || this.props.product.variations[this.state.variationsIndex].data.default_amount;
    data.socialFee = data.socialFee !== '' ? data.socialFee : defaultValues.social_fee_percentage;
    data.workingDaysPerWeek = data.workingDaysPerWeek || defaultValues.weekly_working_days;
    data.workingDaysPerYear = data.workingDaysPerYear || defaultValues.yearly_working_days;

    return data;
  };

  renderVegetableSelects(data, product) {
    return (
      <div>
        {data.map((vegetableSelect, key) => {
          return (
            <div className="vegetable-form-group" key={key}>
              <select className="form-control"
                      onChange={(e) => this.handleVegetableChange(e, key)}
                      value={vegetableSelect.value}
              >
                {product.variations.map((variation, i) =>
                  <option value={i} key={variation.title}>{t(variation.title)}</option>,
                )}
              </select>
              <div className="vegetable-quantity-container">
                <input id="vegetable-quantity-per-day"
                       className="form-control"
                       type="number"
                       name="vegetableQuantityPerDay"
                       placeholder={vegetableSelect.quantityPerDay}
                       onChange={(e) => this.handleVegetableChange(e, key, true)}
                       min={1}
                />
                <div className="quantity-suffix">{t('Kg/ day')}</div>
              </div>
              <button className="removeVegetable" onClick={() => this.removeVegetable(key)}>⨯</button>
            </div>
          );
        })}
      </div>
    );
  }


  removeVegetable(key) {
    const newSelectedVegetables = this.state.selectedVegetables;

    if (newSelectedVegetables.length === 1) {
      return;
    }

    newSelectedVegetables.splice(key, 1);

    const inputData = {
      ...this.state.inputData,
      vegetables: newSelectedVegetables,
    };

    const resultData = calculateRoi(this.fixRoiData(inputData));

    this.setState({
      selectedVegetables: newSelectedVegetables,
      resultData: resultData,
    });
  }

  addVegetable(product) {

    const newSelectedVegetables = this.state.selectedVegetables;

    const {
            human,
            machine,
            default_amount,
          } = product.variations[0].data;

    newSelectedVegetables.push({
      value: 0,
      human: human,
      machine: machine,
      quantityPerDay: Number(default_amount),
    });

    const inputData = {
      ...this.state.inputData,
      vegetables: newSelectedVegetables,
    };

    const resultData = calculateRoi(this.fixRoiData(inputData));

    this.setState({
      selectedVegetables: newSelectedVegetables,
      resultData: resultData,
    });
  }

  render() {
    const {
      products,
      default_values,
      prepend_symbol,
      append_symbol,
    } = this.props;

    function affixPrice(price) {
      return `${prepend_symbol ? prepend_symbol + '&nbsp;' : ''}${price}${append_symbol ? append_symbol + '&nbsp;' : ''}`;
    }

    if (!this.props.product) {
      return (
        <p>{t('Error, can\'t find product.')}</p>
      );
    }

    const {
      moneySavedFirstQuarter,
      moneySavedFirstYear,
      timeSaved,
      timeSavedSuffix,
      paybackTime,
      paybackTimeSuffix,
    } = this.state.resultData;

    return (
      <form onSubmit={e => e.preventDefault()}>
        <div className="row roi_calculator__row">
          <div className="text-center col-md-12">
            <p><strong>{t('You\'ll save')}</strong></p>
            <h2 className="roi_calculator__amount_saved">
              <span>{formatMoney(moneySavedFirstYear, prepend_symbol, append_symbol)}</span>
            </h2>
            <p>{t('by the first')} <strong>{t('12 months')}</strong></p>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor={this.props.id} className="form-label">{t('Vegetable - Cutting tool')}
                <span className="required">*</span></label>
              {this.renderVegetableSelects(this.state.selectedVegetables, this.props.product)}
              <div className="addVegetableButton" onClick={() => this.addVegetable(this.props.product)}>{t('Add vegetable')}</div>
            </div>
          </div>
        </div>
        <div className="row roi_calculator__row">
          <div className="col-md-6">
            <InputGroup id="labour-cost"
                        label={t('Labour cost EUR/ hour') + ':'}
                        placeholder={default_values.hourly_labour_cost}
                        name="labourCostPerHour"
                        suffix={append_symbol || prepend_symbol}
                        onChange={this.handleChange}
            />
            <InputGroup id="social-fee"
                        label={t('Social fees, (percentage of labour cost)') + ':'}
                        placeholder={default_values.social_fee_percentage}
                        name="socialFee"
                        suffix="%"
                        onChange={this.handleChange}
            />
          </div>
          <div className="col-md-6">
            <InputGroup id="working-days-per-week"
                        label={t('Working days per week') + ':'}
                        placeholder={default_values.weekly_working_days}
                        name="workingDaysPerWeek"
                        suffix="days"
                        onChange={this.handleChange}
                        max="7"
            />
            <InputGroup id="working-days-per-year"
                        label={t('Working days per year') + ':'}
                        placeholder={default_values.yearly_working_days}
                        name="workingDaysPerYear"
                        suffix="days"
                        onChange={this.handleChange}
                        max="365"
            />
          </div>
        </div>
        <div className="row roi_calculator__row">
          <div className="col-md-12">
            <div className="form-group row">
              <label htmlFor="list-price" className="col-sm-6 col-form-label">{t('List Price')} {t(this.props.product.title)}</label>
              <div className="col-sm-6">
                <input type="text"
                       disabled
                       className="form-control text-right"
                       id="list-price"
                       value={formatMoney(this.props.product.variations[this.state.variationsIndex].price, prepend_symbol, append_symbol)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <h4>{t('Return of investment')}</h4>
            <table className="table table-striped content-table">
              <tbody>
              <tr>
                <th>{t('After the first quarter')}</th>
                <td className="text-right"><small>{formatMoney(moneySavedFirstQuarter, prepend_symbol, append_symbol)}</small></td>
              </tr>
              <tr>
                <th>{t('After the first year')}</th>
                <td className="text-right"><small>{formatMoney(moneySavedFirstYear, prepend_symbol, append_symbol)}</small></td>
              </tr>
              <tr>
                <th>{t('Time saved')}</th>
                <td className="text-right"><small>{Math.round(timeSaved)} {t(timeSavedSuffix)}</small></td>
              </tr>
              <tr>
                <th>{t('Payback-time')}</th>
                <td className="text-right"><small>{paybackTime.toFixed(1)} {t(paybackTimeSuffix)}</small></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </form>
    );
  }
}

export default Roi;
